module.exports = __webpack_public_path__ + "img/artstation.a056fb98.svg";